import { render } from "./ManufacturerDropdown.vue?vue&type=template&id=218b85da"
import script from "./ManufacturerDropdown.vue?vue&type=script&lang=js"
export * from "./ManufacturerDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__